'use strict';
import 'jquery-ui/ui/widgets/slider';

$(document).ready(function () {
    // мобильный фильтр
    $(".filters-accordion").accordion({
        collapsible: true,
        active: false,
        heightStyle: "content",
        animate: 300
    });

    // Якорь в мобильном фильтре
    $('.filters-accordion_header').bind('click', function () {
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $('.ui-accordion-header-active').offset().top - 64
            }, 300);
        }, 310);
    });

    // ползунки диапазонов
    $("#slider_price, #slider_price_mob").slider({
        range: true,
        min: 1540,
        max: 15000,
        values: [1540, 15000],
        slide: function (event, ui) {
            //Поле минимального значения
            $("#price").val(ui.values[0]);
            //Поле максимального значения
            $("#price2").val(ui.values[1]);
        }
    });

    //Записываем значения ползунков в момент загрузки страницы,
    //То есть значения по умолчанию
    $("#price").val($("#slider_price").slider("values", 0));
    $("#price2").val($("#slider_price").slider("values", 1));

    $('#price').change(function () {
        var val = $(this).val();
        $('#slider_price').slider("values", 0, val);
    });

    $('#price2').change(function () {
        var val = $(this).val();
        $('#slider_price').slider("values", 1, val);
    });

    $('.disabler input:checkbox').change(function () {
        if (this.checked)
            $("#slider_price").slider("disable");
        else
            $("#slider_price").slider("enable");
    });

    $('.can_swim input:checkbox').change(function () {
        if (this.checked)
            $("#waterproof").slider("disable");
        else
            $("#waterproof").slider("enable");
    });

    // Ползунки диапазонов размера циферблата
    $("#bracelet_price, #bracelet_price_mob").slider({
        range: true,
        min: 20,
        max: 55,
        values: [20, 55],
        slide: function (event, ui) {
            //Поле минимального значения
            $("#bracelet_from").val(ui.values[0]);
            //Поле максимального значения
            $("#bracelet_to").val(ui.values[1]);
        }
    });

    // Ползунки водозащиты
    $("#waterproof, #waterproof_mob").slider({
        range: true,
        min: 10,
        max: 200,
        values: [40, 160],
        slide: function (event, ui) {
            //Поле минимального значения
            $("#waterproof-start").val(ui.values[0]);
            //Поле максимального значения
            $("#waterproof-end").val(ui.values[1]);
        }
    });

    $("#waterproof-start").val($("#waterproof-start").slider("values", 0));
    $("#waterproof-end").val($("#waterproof").slider("values", 1));

    $('#waterproof-start').change(function () {
        var val = $(this).val();
        $('#waterproof').slider("values", 0, val);
    });

    $('#waterproof-end').change(function () {
        var val = $(this).val();
        $('#waterproof').slider("values", 1, val);
    });
});